import { money } from "../api";

export const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const TITLES = {
  sales_invoice: ["فاتورة ضريبية", "Tax Invoice"], purchase_invoice: ["فاتورة مشتريات", "Purchase Invoice"],
  sales_quotation: ["عرض سعر", "Quotation"], sales_order: ["أمر بيع", "Sales Order"], purchase_order: ["أمر شراء", "Purchase Order"],
};
export const DEFAULT_THEME = { primary: "#059669", dark: "#0f172a", style: "classic", logo_side: "left", footer_text: "", stamp_size: 170, stamp_pos: "left" };
const STYLE_CSS = {
  classic: () => "",
  modern: (P, D) => `
.fi .top{background:${D};color:#fff;border:none;border-radius:14px;padding:16px 18px;border-bottom:4px solid ${P}}.fi .top .ttl span{color:#cbd5e1}
.fi .sec{background:${P}1f;color:${P};border-radius:8px;border-inline-start:4px solid ${P}}
.fi .items th{background:${P};border-color:${P}}.fi .items th small{color:#ffffffcc}
.fi .lbl{background:${P}0f}.fi .tot tr.g td{background:${P};color:#fff}.fi .tot tr.g .lbl.en{color:#fff}`,
  minimal: (P) => `
.fi .top{border-bottom:1px solid #e2e8f0}.fi .ttl b{color:${P}}
.fi .sec{background:none;color:#0f172a;border-bottom:2px solid ${P};padding:4px 0}
.fi .items th{background:#f8fafc;color:#0f172a;border:none;border-bottom:2px solid ${P}}.fi .items th small{color:#64748b}
.fi .items td,.fi .meta td,.fi .party td,.fi .tot td{border:none;border-bottom:1px solid #e2e8f0}
.fi .lbl{background:none;color:#64748b}.fi .tot tr.g td{background:none;color:${P};border-bottom:2px solid ${P}}`,
};
export const themeCss = (t) => {
  const { primary: P, dark: D, style } = { ...DEFAULT_THEME, ...(t || {}) };
  return `
.fi{font-family:"IBM Plex Sans Arabic",Tahoma,sans-serif;color:#0f172a;font-size:11px;direction:rtl;width:794px;padding:34px 38px;box-sizing:border-box;background:#fff}
.fi *{box-sizing:border-box}.fi table{width:100%;border-collapse:collapse}
.fi .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid ${P};padding-bottom:12px}
.fi .ttl{text-align:center}.fi .ttl b{display:block;font-size:20px}.fi .ttl span{font-size:13px;color:#475569;letter-spacing:.5px}
.fi .logo{max-height:70px;max-width:150px;object-fit:contain}
.fi .banks{width:100%;border-collapse:collapse;margin-top:6px;font-size:10px}.fi .banks td,.fi .banks th{border:1px solid #e2e8f0;padding:4px 6px;text-align:right}.fi .banks th{background:#f8fafc}
.fi .stamp{max-height:170px;max-width:230px;object-fit:contain;opacity:.9}
.fi .meta td,.fi .party td{border:1px solid #cbd5e1;padding:5px 7px}
.fi .lbl{background:#f1f5f9;color:#334155;font-weight:600;width:24%}.fi .en{direction:ltr;text-align:left;color:#64748b}
.fi .sec{background:${P};color:#fff;font-weight:700;padding:5px 8px;margin-top:12px;display:flex;justify-content:space-between}
.fi .items th{background:${D};color:#fff;padding:6px 4px;font-size:10px;border:1px solid ${D}}
.fi .items th small{display:block;font-weight:400;color:#cbd5e1}
.fi .items td{border:1px solid #cbd5e1;padding:6px 4px;text-align:center}.fi .items td.d{text-align:right}
.fi .n{direction:ltr;unicode-bidi:isolate;font-variant-numeric:tabular-nums}
.fi .tot td{border:1px solid #cbd5e1;padding:6px 8px;white-space:nowrap}.fi .tot .lbl{width:auto;font-size:11px}.fi .tot td:nth-child(2){text-align:center}.fi .tot tr.g td{background:${P}1a;font-weight:800;font-size:13px}
.fi .foot{margin-top:18px;display:flex;justify-content:space-between;align-items:flex-end;gap:16px}
.fi .qr{width:120px;height:120px;border:1px solid #e2e8f0;padding:4px}
.fi .note{font-size:10px;color:#64748b;border-top:1px dashed #cbd5e1;margin-top:16px;padding-top:6px;text-align:center}
.fi .internal{background:#fef3c7;color:#92400e;border:1px solid #f59e0b;padding:4px 8px;font-weight:700;text-align:center;margin-top:8px}${(STYLE_CSS[style] || STYLE_CSS.classic)(P, D)}`;
};

export const RIYAL = `<svg viewBox="0 0 1124.14 1256.39" fill="currentColor" style="width:.85em;height:.85em;display:inline-block;vertical-align:-.08em;margin-inline-start:3px"><path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>`;
const sr = (v) => `<span class="n">${money(v)}${RIYAL}</span>`;
const nat = (a) => {
  if (!a) return "";
  const parts = [a.building_number && `مبنى ${a.building_number}`, a.street && `شارع ${a.street}`, a.district && `حي ${a.district}`, a.city,
    a.postal_code && `الرمز البريدي ${a.postal_code}`, a.additional_number && `الرقم الإضافي ${a.additional_number}`].filter(Boolean);
  return parts.length ? parts.join("، ") : [a.address, a.city].filter(Boolean).join(" - ");
};
export const nationalAddress = nat;
const row2 = (ar, en, val) => `<tr><td class="lbl">${ar}</td><td>${val}</td><td class="lbl en">${en}</td></tr>`;

function banksHtml(banks, stamp, th) {
  const rows = (banks || []).filter((b) => b.show_on_invoice !== false && (b.iban || b.account_number));
  if (!rows.length && !stamp) return "";
  const pos = th.stamp_pos || "left";
  const dir = pos === "right" ? "row-reverse" : pos === "center" ? "column" : "row";
  return `<div style="display:flex;flex-direction:${dir};gap:12px;align-items:${pos === "center" ? "stretch" : "flex-end"};margin-top:12px">
    <div style="flex:${pos === "center" ? "none" : "1"}">${rows.length ? `<div class="sec"><span>الحسابات البنكية</span><span>Bank Accounts</span></div>
      <table class="banks"><tr><th>البنك</th><th>اسم الحساب</th><th>رقم الحساب</th><th>IBAN</th></tr>
      ${rows.map((b) => `<tr><td>${esc(b.bank_name)}</td><td>${esc(b.account_name)}</td><td class="n">${esc(b.account_number)}</td><td class="n">${esc(b.iban)}</td></tr>`).join("")}</table>` : ""}</div>
    ${stamp ? `<div style="text-align:center;align-self:${pos === "center" ? "center" : "flex-end"}"><img class="stamp" style="max-height:${th.stamp_size}px;max-width:${Math.round(th.stamp_size * 1.4)}px" src="${stamp}"/><div style="font-size:9px;color:#64748b">ختم الشركة · Company Stamp</div></div>` : ""}
  </div>`;
}

export function buildInvoiceHtml(d, { seller, logo, qr, internal, theme }) {
  const th = { ...DEFAULT_THEME, ...(theme || {}) };
  const [tAr, tEn] = d.doc_type === "sales_invoice" && d.invoice_kind === "simplified"
    ? ["فاتورة ضريبية مبسطة", "Simplified Tax Invoice"] : TITLES[d.doc_type] || ["مستند", "Document"];
  const isSale = d.doc_type.startsWith("sales");
  const showCost = internal && d.lines.some((l) => l.cogs != null);
  const head = [["#", "No."], ["الوصف", "Description"], ["الكمية", "Qty"], ["سعر الوحدة", "Unit Price"], ["الخصم", "Discount"],
    ["المبلغ الخاضع", "Taxable"], ["نسبة الضريبة", "VAT %"], ["الضريبة", "VAT"], ["الإجمالي", "Total"],
    ...(showCost ? [["التكلفة", "COGS"], ["الربح", "Profit"], ["الهامش", "Margin"]] : [])];
  const body = d.lines.map((l, i) => `<tr><td>${i + 1}</td><td class="d">${esc(l.description || "—")}</td><td class="n">${l.qty}</td>
    <td class="n">${money(l.price)}</td><td class="n">${money(l.discount)}</td><td class="n">${money(l.taxable)}</td>
    <td class="n">${l.tax_rate}%</td><td class="n">${money(l.vat)}</td><td class="n"><b>${money(l.total)}${RIYAL}</b></td>
    ${showCost ? `<td class="n">${l.cogs != null ? money(l.cogs) : "—"}</td><td class="n">${l.profit != null ? money(l.profit) : "—"}</td><td class="n">${l.margin != null ? l.margin + "%" : "—"}</td>` : ""}</tr>`).join("");
  const s = seller || {};
  return `<div class="fi"><style>${themeCss(th)}</style>
  <div class="top" style="${th.logo_side === "right" ? "flex-direction:row-reverse" : ""}">
    <div style="width:34%">${s.name ? `<b style="font-size:14px">${esc(s.name)}</b><br/>` : ""}${s.name_en ? `<span class="en" style="display:block">${esc(s.name_en)}</span>` : ""}
      ${s.vat ? `الرقم الضريبي: <span class="n">${esc(s.vat)}</span><br/>` : ""}${s.cr ? `السجل التجاري: <span class="n">${esc(s.cr)}</span><br/>` : ""}${esc(nat(s))}</div>
    <div class="ttl" style="width:32%"><b>${tAr}</b><span>${tEn}</span></div>
    <div style="width:34%;display:flex;align-items:flex-start;justify-content:flex-start;direction:${th.logo_side === "right" ? "rtl" : "ltr"}">${logo ? `<img class="logo" src="${logo}"/>` : ""}</div>
  </div>
  ${internal ? `<div class="internal">نسخة داخلية — تحتوي على التكلفة والربح · لا تُسلَّم للعميل · Internal copy</div>` : ""}
  <table class="meta" style="margin-top:12px">
    ${row2("رقم الفاتورة", "Invoice No.", `<span class="n"><b>${esc(d.number)}</b></span>`)}
    ${row2("تاريخ الإصدار", "Issue Date", `<span class="n">${esc(d.date)}</span>`)}
    ${d.due_date ? row2("تاريخ الاستحقاق", "Due Date", `<span class="n">${esc(d.due_date)}</span>`) : ""}
  </table>
  <div class="sec"><span>${isSale ? "بيانات العميل" : "بيانات المورد"}</span><span>${isSale ? "Buyer" : "Supplier"}</span></div>
  <table class="party">
    ${row2("الاسم", "Name", esc(d.party_name || "—"))}
    ${row2("الرقم الضريبي", "VAT No.", `<span class="n">${esc(d.party_vat || "—")}</span>`)}
    ${nat(d._party) ? row2("العنوان الوطني", "National Address", esc(nat(d._party))) : ""}
  </table>
  <div class="sec"><span>البنود</span><span>Line Items</span></div>
  <table class="items"><thead><tr>${head.map(([a, e]) => `<th>${a}<small>${e}</small></th>`).join("")}</tr></thead><tbody>${body}</tbody></table>
  <div class="foot">
    <div>${qr ? `<img class="qr" src="${qr}"/>` : ""}</div>
    <table class="tot" style="width:auto;min-width:55%">
      ${row2("الإجمالي قبل الضريبة", "Total excl. VAT", sr(d.subtotal))}
      ${d.total_discount ? row2("إجمالي الخصم", "Discount", sr(d.total_discount)) : ""}
      ${row2("ضريبة القيمة المضافة", "Total VAT", sr(d.total_vat))}
      <tr class="g"><td class="lbl">الإجمالي المستحق</td><td>${sr(d.total)}</td><td class="lbl en">Total Amount Due</td></tr>
      ${showCost ? `${row2("تكلفة البضاعة المباعة", "COGS", sr(d.total_cogs))}${row2("مجمل الربح", "Gross Profit", `<span class="n">${money(d.gross_profit)} (${d.gross_margin}%)</span>`)}` : ""}
    </table>
  </div>
  ${d.notes ? `<div style="margin-top:10px"><b>ملاحظات:</b> ${esc(d.notes)}</div>` : ""}
  ${banksHtml(isSale ? s.banks : null, s.stamp, th)}
  ${th.footer_text ? `<div style="margin-top:12px;font-size:10px;color:#334155;white-space:pre-line;border-inline-start:3px solid ${th.primary};padding:4px 8px">${esc(th.footer_text)}</div>` : ""}
  <div class="note">${d.zatca ? "فاتورة إلكترونية متوافقة مع متطلبات هيئة الزكاة والضريبة والجمارك · ZATCA compliant e-invoice" : ""}${d.zatca?.uuid ? ` · UUID: <span class="n">${esc(d.zatca.uuid)}</span>` : ""}</div>
</div>`;
}

export function printInvoice(html, title) {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<html dir="rtl"><head><meta charset="utf-8"><title>${esc(title)}</title><style>@page{size:A4;margin:0}body{margin:0}</style></head><body>${html}</body></html>`);
  w.document.close();
  w.onload = () => { w.focus(); w.print(); };
  setTimeout(() => { try { w.focus(); w.print(); } catch (e) { /* noop */ } }, 900);
  return true;
}

export async function pdfInvoice(html, filename) {
  (await invoicePdf(html)).save(filename);
}

export async function invoicePdf(html) {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([import("html2canvas"), import("jspdf")]);
  const host = document.createElement("div");
  host.style.cssText = "position:fixed;left:-10000px;top:0;z-index:-1";
  host.innerHTML = html;
  document.body.appendChild(host);
  try {
    await new Promise((r) => setTimeout(r, 300));
    const canvas = await html2canvas(host.firstElementChild, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
    const pdf = new jsPDF({ unit: "mm", format: "a4" });
    const pw = 210, ph = 297, imgH = (canvas.height * pw) / canvas.width;
    let y = 0;
    while (y < imgH) {
      if (y > 0) pdf.addPage();
      pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", 0, -y, pw, imgH);
      y += ph;
    }
    return pdf;
  } finally { host.remove(); }
}
